export default{
    imgBaseUrl:process.env.NODE_ENV === 'development' ? process.env.VUE_APP_API_BASE_URL : window.location.origin,
}